'use client';

import { Autocomplete } from '@mantine/core';
import ArrowDropDown from '@material-design-icons/svg/filled/arrow_drop_down.svg';
import React, { useEffect, useState } from 'react';
import { useRefinementList, UseRefinementListProps } from 'react-instantsearch';

import styles from './CustomRefinementList.module.css';

type AutocompleteRefinementListProps = UseRefinementListProps & {
  placeholder?: string;
  onSelect?: (value: string) => void;
  isDisabled?: boolean;
};

export function CustomAutocompleteRefinement({
  placeholder = 'Filter...',
  onSelect,
  isDisabled = false,
  ...props
}: AutocompleteRefinementListProps) {
  const { items, refine } = useRefinementList(props);
  const [value, setValue] = useState('');

  const data = items.map((item) => ({
    value: item.value,
    label: item.label,
  }));

  const handleSubmit = (val: string) => {
    const match = items.find((item) => item.value === val);
    if (match) {
      // Clear all previous refinements
      items.forEach((item) => {
        if (item.isRefined) {
          refine(item.value); // toggle off
        }
      });

      setValue(val);
      refine(val); // Only refine if it's a valid refinement
      onSelect?.(val);
    }
  };

  useEffect(() => {
    if (!items.find((item) => item.value === value)) {
      setValue('');
    }
  }, [items, value]);

  return (
    <Autocomplete
      variant="filled"
      classNames={{
        input: styles.input,
        dropdown: styles.dropdown,
      }}
      rightSection={<ArrowDropDown />}
      value={value}
      onChange={setValue} // Just set the local input
      onOptionSubmit={handleSubmit} // Only refine on confirmed selection
      data={data}
      placeholder={placeholder}
      maxLength={30}
      disabled={isDisabled}
    />
  );
}
